<template>
  <div class="ce-wrapper">
    <div v-if="editMode" :class="'ce ce-' + content.type + ' ce-edit-mode'">
      <div class="edit-header d-flex align-items-center">
        <h5 class="mb-0">
          <span class="text-success"><i class="fas fa-align-left"></i></span>
          Text
        </h5>
        <CeButtonGroup
          v-on:on-remove-click="onRemoveClick"
          v-on:on-arrow-up-click="onArrowUp"
          v-on:on-arrow-down-click="onArrowDown"
        />
      </div>
      <b-form-group>
        <b-form-input
          @change="updateHeadline"
          :value="content.headline"
          :id="'ceTextHeadline' + content.id"
          placeholder="Rubrik för texten... (valfritt)"
        ></b-form-input>
      </b-form-group>
      <b-form-group>
        <TextEditor
          v-on:on-body-update="updateBody"
          :id="content.id"
          :body="content.body"
        />
      </b-form-group>
    </div>
    <div v-else :class="'ce ce-' + content.type + ' editMode'">
      <h3 v-if="content.headline" class="ce-headline mb-1">
        {{ content.headline }}
      </h3>
      <div class="ce-body" v-html="content.body">{{ content.body }}</div>
    </div>
  </div>
</template>

<script>
import { BFormGroup, BFormInput } from "bootstrap-vue";
import CeButtonGroup from "@/components/Article/ContentElements/CeButtonGroup";
import TextEditor from "@/components/quillEditor/TextEditor";
import ContentElementButtonGroupMixin from "@/models/mixins/ContentElementButtonGroupMixin";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("editArticle");

export default {
  name: "CeText",
  props: {
    content: {},
    editMode: Boolean,
  },
  methods: {
    ...mapActions(["updateContent", "uploadContentImage"]),
    updateHeadline(headline) {
      let content = this.content;
      content.headline = headline;
      this.updateContent(content);
    },
    updateBody(html) {
      let content = this.content;
      content.body = html;
      this.updateContent(content);
    },
  },
  components: {
    TextEditor,
    CeButtonGroup,
    BFormInput,
    BFormGroup,
  },
  mixins: [ContentElementButtonGroupMixin],
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/variables/_variables.scss";
</style>
